var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-return-await */
import axios from 'axios';
import { EAxiosMethod } from '../types/api';
const baseURL = process.env.API_URL || '/api';
const callApi = ({ method, path, data, params = {}, headers = {} }) => __awaiter(void 0, void 0, void 0, function* () {
    const config = {
        baseURL,
        url: path,
        method: method || EAxiosMethod.GET,
        params,
        data,
        headers: Object.assign(Object.assign(Object.assign({}, axios.defaults.headers.common), { 'Content-Type': 'application/json' }), headers),
    };
    // console.log('api.callApi config', config)
    const response = yield axios(config);
    return response.data;
});
export const get = ({ path, params, data, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.GET, path, params, headers, data }); });
export const post = ({ path, data, params, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.POST, path, data, params, headers }); });
export const put = ({ path, data, params, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.PUT, path, data, params, headers }); });
export const del = ({ path, params, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.DELETE, path, params, headers }); });
export const setAccessToken = (token) => __awaiter(void 0, void 0, void 0, function* () {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
});
export const removeAccessToken = () => {
    delete axios.defaults.headers.common.Authorization;
};
